import { PropsWithChildren } from 'react';
import { CommonProvider } from '@starsoft/common/providers';
import useTranslation from 'next-translate/useTranslation';
import Trans from 'next-translate/Trans';
import TransText from 'next-translate/TransText';
import { CommonSettings } from '@starsoft/common/interfaces';
import { NextNavigate } from '@starsoft/common/components';
import {
  useNextNavigate,
  useNextPathname,
  useNextHash,
  useNextSearchParams,
} from '@starsoft/common/hooks';
import { Observable } from 'redux';

export default function PackageCommonSettingsProvider({
  children,
}: PropsWithChildren) {
  const settings: CommonSettings = {
    useTranslation: useTranslation,
    translationComponents: {
      Trans: Trans,
      TransText: TransText,
    },
    router: {
      useNavigate: useNextNavigate,
      usePathname: useNextPathname,
      useSearchParams: useNextSearchParams,
      useHash: useNextHash,
      Navigate: NextNavigate,
      Link: null,
    },
    store: {
      getState: () => ({}),
      dispatch: (action: any) => action,
      subscribe: () => {
        return () => {};
      },
      replaceReducer: () => {},
      [Symbol.observable]: function (): Observable<any> {
        throw new Error('Function not implemented.');
      },
    },
  };

  return <CommonProvider settings={settings}>{children}</CommonProvider>;
}
